import { StatusType } from 'types';

import { useStatus } from './Status.hooks';
import * as S from './Status.styles';

type StatusProps = {
  status: StatusType;
};

export function Status(props: StatusProps): React.ReactElement {
  const { status } = { ...props };

  const { chooseStatus } = useStatus();
  const { background, color, label } = chooseStatus(status);

  return (
    <S.Container background={background}>
      <S.Label textTransform="capitalize" color={color}>
        {label}
      </S.Label>
    </S.Container>
  );
}
